/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { DilutionTank } from "./modelDilutionTank";

class ControllerDilutionTank extends ControllerModel {
    constructor() {
        super("ControllerDilutionTank");

        this.setNewNode = (callback) => {
            let dilutionTank = new DilutionTank();
            dilutionTank.decorate(callback);

            this.addNode(dilutionTank);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let dilutionTank = new DilutionTank();
            dilutionTank.copyFrom(node);
            dilutionTank.decorate(callback);
            this.addNode(dilutionTank)
        }

        this.getProperties = async (node) => {
            let n = new DilutionTank();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new DilutionTank();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerDilutionTank };